export class Constants {
    // global values
    public static FIELD_REQUIRED_MESSAGE = 'This field is required';
    public static PRIMARY_LEVEL = 1;
    public static SECONDARY_LEVEL = 2;
    public static TERTIARY_LEVEL = 3;
    public static NOTIFY_DURATION = 5000; // mliseconds
    public static DEFAULT_PART_MATERIAL = 'Unknown';
    public static REJECTED_REASON_ID_OTHER = 20;
    public static SOURCETYPEID_SERVICE = 58;
    public static TEMPLATE_PREFIX_HARDCODED_PKGPART = '_Pkg_';
    public static FILE_UPLOAD_MAX_SIZE = 2.5e+7; // value in bytes (25.0 MB)
    public static FILE_UPLOAD_MAX_SIE_BYTES = 20971520;
    public static MAX_ALLOWED_STACKABLE_UNITS_SHIPPING = 20;
    public static ID_OTHER_REASON_NONSUB_TESTDOC = 9;

    // max stack height
    // FORMAT: sourcetypeId : array {transport Id, max allowed stack height value}
    // Transport Ids:  Ocean=1, Ground=2, Air=3
    public static MAXSTACK = {
        56: [{transportmodeid: 2, maxstackheight:108}, 
            {transportmodeid: 1, maxstackheight: 106}],
        58: [{transportmodeid: 2, maxstackheight:108}, 
                {transportmodeid: 1, maxstackheight: 106}],
        64: [{transportmodeid: 2, maxstackheight:108}, 
                    {transportmodeid: 1, maxstackheight: 106}],
        104: [{transportmodeid: 2, maxstackheight:108}, 
                        {transportmodeid: 1, maxstackheight: 106}],
        1315: [{transportmodeid: 2, maxstackheight:108}, 
                            {transportmodeid: 1, maxstackheight: 106}],
        1682: [{transportmodeid: 2, maxstackheight:108}, 
                                {transportmodeid: 1, maxstackheight: 106}],
    }

    // success messages
    public static SUCCESS_SUBMITTED_GENERIC = 'submitted successfully...';
    public static SUCCESS_SAVE_GENERIC = 'saved successfully...';
    public static SUCCESS_IMAGE_UPLOAD = 'Image(s) uploaded successfully...';
    public static SUCCESS_FILE_UPLOAD = 'File(s) uploaded successfully...';

    // error messages
    public static ERROR_MESSAGE_FOR_PROPOSAL_EXISTS = ' already has proposal(s) with draft/submitted/rejected status'
    public static ERROR_STACKABILITY_MISSING_INPUT  = 'At least one input missing for computation';

    public static ERROR_PROPOSAL_CHECK_VALIDATIONS =
        'Please check all tabs for validation errors';

    // workflow status
    public static WORKFLOW_STATUS_NEW = 1;
    public static WORKFLOW_STATUS_SUBMITTED = 2;
    public static WORKFLOW_STATUS_REJECTED = 3;
    public static WORKFLOW_STATUS_APPROVED = 4;
    public static WORKFLOW_STATUS_PENDINGVALIDATION = 5;
    public static WORKFLOW_STATUS_INCOMPLETE = 6;
    

        // proposal estimate request status
        public static PROPOSAL_ESTIMATE_REQUEST_STATUS_NEW = 1;
        public static PROPOSAL_ESTIMATE_REQUEST_STATUS_SUBMITTED = 2;
        public static PROPOSAL_ESTIMATE_REQUEST_STATUS_REJECTED = 3;
        public static PROPOSAL_ESTIMATE_REQUEST_STATUS_APPROVED = 4;
    
    public static WORKFLOW_ACTIVE_PROPOSAL_CSS_STYLE_CLASS = 'ActiveProposalRow';

    //scroll amount
    public static LEFT_MENU_SCROLL_VERTICAL_PIXELS = 87;

    // filter data types
    public static FILTER_DATATYPE_NUMBER  = 1;
    public static FILTER_DATATYPE_STRING  = 2;
    public static FILTER_DATATYPE_DATE  = 3;
    public static FILTER_DATATYPE_DATETIME  = 4;
    public static FILTER_DATATYPE_BOOLEAN = 5;


    // filter operator type
    public static FILTER_OPERATOR_TYPE_EQUAL  = 1;
    public static FILTER_OPERATOR_TYPE_LIKE  = 2;
    public static FILTER_OPERATOR_TYPE_GREATERTHAN  = 3;
    public static FILTER_OPERATOR_TYPE_LESSTHAN  = 4;

    // Unit of Measurements
    public static IMPERIAL_UOM_ID = 1;
    public static METRIC_UOM_ID = 2;
    public static LOCATIONS_FOR_METRIC_UOM_ID = [331, 668, 909, 935, 1109, 2222];
    public static IMPERIAL_WEIGHT_FACTOR = 2.204622622;
    public static IMPERIAL_DIM_FACTOR = 25.4;
    // Tesla Code Equipment length
    public static TeslaCodeEquipmentMaxLength = 45;

    // Enovia Code length
    public static EnoviaCodeMaxLength = 30;

    //Packageing Type Description
    public static ReturnablePackagingTypeId = 1;
    public static ExpendablePackagingTypeId = 2;

    //set default class name for div tag
    public static DefaultClassName = "content";

    //Max no of times ShipDate can be extended by suppliers
    public static MaxNooftimesShipDateExtendedBySupplier = 3;

    //Ad DDE Request Status Id
    public static AdhocDDE_REQUESTED_STATUS_ID = 1;
    public static AdhocDDE_APPROVED_STATUS_ID = 2;
    public static AdhocDDE_REJECTED_STATUS_ID = 3;

    //Request Status for Ad hoc DDE Requests 
    public static AdhocDDE_STATUS_REQUESTED = "Requested";
    public static AdhocDDE_STATUS_APPROVED = "Approved";
    public static AdhocDDE_STATUS_REJECTED = "Rejected";

    //PE Assignment Tab headings
    public static UNASSIGNED = "Unassigned";
    public static CURRENT_ASSIGNMENTS = "CurrentAssignments";
    public static ADD_NEW_ASSIGNMENT = "AddNewAssignment";

    static localStorageKeys = class {

         public static IdToken = 'IdToken';
         public static CurrentSupplierCode = 'CurrentSupplierCode';
         public static CorrelationId = 'CorrelationId';
         public static XPortalIdentityUserName = 'X-PortalIdentity-UserName';
         public static UISupplierContexts = 'UISupplierContexts';
         public static IsEmployee = 'IsEmployee';
         public static IsReadOnlyUser = 'IsReadOnlyUser';
         public static IsAdmin = 'IsAdmin';
         public static IsLoggedInAsSupplier = 'IsLoggedInAsSupplier';
         public static IsSupplier = 'IsSupplier';
         public static UserDisplayName = 'UserDisplayName';
         public static UserEmail = 'ssEmail';
         public static RedirectUrl = 'RedirectUrl';
         public static CountBadges = 'CountBadges';
    };

    // TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
    static storageSettingKeys = class {
        public static readonly STORAGE_SETTING_PACKAGING_PREFIX = 'packaging:';
        public static readonly STORAGE_SETTING_PACKAGING_ATTRIBUTES_PREFIX = + 'packaging:attrs:';
        public static readonly STORAGE_SETTING_LOGGED_IN = 'packaging:attrs:loggedin';
        public static readonly STORAGE_SETTING_WARP_USER_ID = 'packaging:attrs:warpUserId';
        public static readonly STORAGE_SETTING_SUPPLIER_CODE = 'packaging:attrs:supplierCode';
    }

    static systemParameters = class {
        public static readonly AGING_DAYS = 'Aging_Days';
        public static readonly MAX_DAYS_DUE_DATE_EXTENSION = 'MaxDaysDueDateExtension';
        public static readonly MAX_NO_OF_TIMES_DUE_DATE_EXTENSION = 'MaxNoOfTimesDueDateExtension';
        public static readonly MAX_OFFSET_DAYS_FOR_DUE_DATE_EXTENSION = 'MaxOffsetDaysForDueDateExtension';
    };

    public static IsEmployeeCheckCode: string = '8Hk3jykio5Nu383E';
    public static IsAdminCheckCode: string = '19Jiwe38UJnQNsa738A';
    public static ReadOnlyUserSecurityKey: string = 'A3lds9KFIWY30ppC';
    public static IsLoggedAsSupplierSecurityKey = '7AKLe32Klab2poc';

    public static DimensionsMaxLength = 700;
    public static DimesionsMaxWidth = 200;
    public static DimensionsMaxHeight = 200;
    public static MaxTareWeight = 65000;
    public static MaxAllowedMaxWeight = 65000;

    public static DimensionsMinLength_Shippable = 1;
    public static DimensionsMinLength_NotShippable = .0001;
    public static DimesionsMinWidth_Shippable = 1;
    public static DimesionsMinWidth_NotShippable = .0001;
    public static DimensionsMinHeight_Shippable = 1;
    public static DimensionsMinHeight_NotShippable = .0001;
    public static MinTareWeight = 0.0001;
    public static MinAllowedMaxWeight = 0.1;

    public static StackabilityParameterMaxValue = 20;

    // info tooltips
    public static TOOLTIP_PACKAGE_TYPE = '<b>Package Type</b><br><br>Expendable: Packaging intended to be discarded after use (corrugated boxes, wooden pallets, etc.). <br>Returnable: Packaging intended to be reused (plastic totes, steel racks, bulk bins, etc.)';
    public static TOOLTIP_EFFECTIVE_FROM = '<b>Effective From</b><br><br>The effectivity date is the date in which the proposed packaging will begin shipping. The proposal will not become active in the system until the effectivity date is reached, at which point any previous submissions for the same part number and business location will be deactivated.';
    public static TOOLTIP_STACKABILITY = `<b>Stackability</b><br><br>Is the unit load able to be stacked on top of another identical unit load? If non-stackable is chosen, this means the unit load cannot be stacked due to its shape, contents, packaging, or potential safety concerns.<br><br>
    Please note, per Tesla’s packaging guidelines, it is required to have stackable unit loads unless there is a valid reason that this is not possible.`;
    public static TOOLTIP_NO_OF_STACKABLE_UNITS_FOR_SHIPPING = '<b>No. of Stackable Units For Shipping</b><br><br>How many unit loads can be stacked during transit? The unit load height and the internal height of the trailer/shipping container should be considered. This number should include the total number of unit loads in one vertical stack, including the unit load on the bottom. <br>(Max allowed value = 20)';
    public static TOOLTIP_NO_OF_STACKABLE_UNITS_FOR_WAREHOUSING = '<b>No. of Stackable Units For Warehousing</b><br><br>How many unit loads can safely be stacked during warehousing? This number should include the total number of unit loads in one vertical stack, including the unit load on the bottom. <br>(Max allowed value = 20)';
    public static TOOLTIP_REASON_FOR_NON_STACKABILITY = `<b>Reason for Non-Stackability</b><br><br>Please provide a clear explanation for why the proposed unit loads are not able to be stacked.<br><br>
    Please note, per Tesla’s packaging guidelines, it is required to have stackable unit loads unless there is a valid reason that this is not possible.`;
    public static TOOLTIP_FIT_FOR_AIR_SHIPMENT = '<b>Fir for Air Shipment</b><br><br>Can the proposed packaging be shipped via air if necessary?';
    public static TOOLTIP_ROTATION_FEASIBLE = `<b>Rotation Feasible?</b><br><br>Can the unit load be loaded into the trailer at 90°? Is there any reason the unit load can only be loaded in one direction? If a unit load significantly underutilizes the volume of the trailer/shipping container when loaded in a specific direction, rotation should be marked non-feasible.<br><br>
    <u>Example 1</u>: Using a 2-way pallet may prevent a unit load from being loaded at 90°. A 2-way pallet has fork pockets on only 2 of 4 sides, preventing forklift drivers from picking up the pallet on the 2 sides without fork pockets. In this case, rotation should be marked non-feasible.<br><br>
    <u>Example 2</u>: When shipping a 1470x1140mm unit load via ocean, the unit load should be placed in the shipping container with the 1140mm dimension in the width of the container. This will allow 2 unit loads to fit side by side in the width. Orienting the unit load with the 1470mm unit load dimension in the width, will result in the rest of the width of the trailer to go unutilized. In this case, rotation should be marked non-feasible.`;
    public static TOOLTIP_ROTATION_COMMENT = '<b>Rotation Comment</b><br><br>Please provide a clear explanation for why the proposed unit loads are not able to be rotated.';
    public static TOOLTIP_TARE_WEIGHT = '<b>Tare weight</b><br><br>Tare weight is the weight of the empty packaging only.';
    public static TOOLTIP_QPC = '<b>QPC</b><br><br>What is the quantity of parts per container (QPC)?';
    public static TOOLTIP_DUNNAGE_TYPES = '<b>Dunnage Types</b><br><br>Internal dunnage: Packaging material used to protect the contents within a package (polybags, corrugated partitions, layer pads, VCI bags, ESD bags, etc.). <br><br>Unit load dunnage: Packaging material used to secure and support the unit load (stretch wrap, banding, corner supports, etc.). <br><br>If you are not using dunnage, select “None”.';
    public static TOOLTIP_PART_IMAGES = '<b>Part Images</b><br><br>Please provide a minimum of 2 part images from different points of view.';
    public static TOOLTIP_NON_STANDARD_PACKAGING = 'When selecting a non-standard packaging, please provide dimensions in the "Computed Values" section below.';
    public static TOOLTIP_PACKAGING_IMAGES = `<b>Packaging Images</b><br><br>Please provide a minimum of 2-3 packaging images. Images must include proof of dimensions using a ruler or measuring tape.<br><br>
    Useful packaging images include:<br>
    • Primary packaging image<br>
    • Interior of primary packaging with parts<br>
    • Unit load image`;
    public static TOOLTIP_DOCUMENTS = '<b>Documents</b><br><br>Supplementary packaging documents. May include test reports, technical drawings and prints, etc.';
    public static TOOLTIP_TESTING_DOCUMENTS = '<b> Proof of Testing/Validation </b><br><br> Please provide testing documentation. If testing documentation is not available, please provide a reason. <br/>(Reminder: it is the responsibility of the supplier to take all the necessary steps to properly design and validate the packaging to ensure the parts arrive to Tesla in usable condition)';
    public static TOOLTIP_PACKAGE_CODE = `<b>Package Code</b><br><br>Choose the Tesla standard package code that corresponds to the packaging you are shipping.<br><br>

    IMC-ISO: Overseas International Packaging<br>
    TMC-NA: North America Domestic Packaging<br>
    ZMC-CN: China Domestic Packaging<br>
    EMC-EU: Europe Domestic Packaging<br><br>

    Any deviations from the Tesla packaging standards must be approved in writing by a Tesla Packaging Engineer. Unapproved or noncompliant deviations may result in chargebacks.<br><br>

    If you have received written approval from a Tesla Packaging Engineer to deviate from the standard packaging, a new package code can be created on the Package Templates page. Any package templates created must match the chosen package type, transport mode, and dimensions of the packaging you are shipping.`;

    public static TOOLTIP_PE_ASSIGNMENT_FOR_SUPPLIER = '<b>Supplier Name/Code</b><br><br>Already assigned Supplier codes will not be shown for selection.';
    public static TOOLTIP_PE_ASSIGNMENT_FOR_SIOCODE = '<b>SIO Code</b><br><br>Before selecting SIO Code, please select Supplier Code.';

    public static TOOLTIP_PACKAGE_TEMPLATE_FOR_SUPPLIERS = '<b>Supplier Name/Code</b><br><br>Select Supplier name to be associated with Package Template';

    public static TOOLTIP_DUE_DATE_EXTENSION_DETAILS = `<b>Due Date Extension Details</b>
    <br><br>
    • Suppliers can self extend the due date a maximum of 7 days at a time. <br>
    • Supplier can change due date in total of 3 times.<br>
    • Supplier can change Due Date by clicking due date for selected proposal. <br>
    • To view the due date history click on the due date`;

    public static TOOLTIP_PACKAGE_TYPE_FILTER_FOR_SEARCHPART_SCREEN = 'The <b>Package Type</b> filter applies to proposals. Parts having proposals with only the selected package type will be shown.';
    public static TOOLTIP_PACKAGE_TYPE_FILTER_FOR_SEARCHPART_SCREEN_ID =  26;
    public static TOOLTIP_SERVICE_OPTIMIZED = 'Mark this true only if the proposal is service specific.';

    // confirmation prompts
    public static CONFIRM_PROMPT_COPY_EARLIER_TARGET_DATE_1: string = 'There is an existing proposal with effective from date as ';
    public static CONFIRM_PROMPT_COPY_EARLIER_TARGET_DATE_2: string = '. Please confirm if you wish to create a new proposal with an earlier effective from date. Please note the existing proposal will be disabled and the new proposal will be considered "End of time"';
    public static LEAVE_GAP: number = 2;
    public static BRIDGE_GAP: number = 1;
}   


